<template>
  <!-- 网点管理 -->
  <div class="page-container">
    <div class="page-top-tool">
      <!-- <el-button v-if="userPrower == '1'" type="success" icon="el-icon-plus" size="mini" @click="toAddStorePage">新增企业</el-button> -->
      <div class="right-search">
        <span style="margin-left: 20px;">企业编号：</span>
        <el-input v-model="info_no" clearable placeholder="请输入企业编号" :disabled="loading" size="mini" style="width: 230px;"></el-input>
        <el-button type="primary" icon="el-icon-search" size="mini" :disabled="loading" style="margin-left: 20px;" @click="onSearch">搜索</el-button>
      </div>
    </div>
    <el-table
      :data="tableData"
      v-loading="loading"
      element-loading-text="数据加载中"
      element-loading-spinner="el-icon-loading"
      style="width: 100%; font-size: 12px; margin: 20px 0px;"
      :header-cell-style="tableHeaderColor"
    >
      <el-table-column prop="info_no" label="公司编号" width=""></el-table-column>
      <el-table-column prop="name" label="公司名称" width=""></el-table-column>
      <el-table-column label="公司Logo" width="">
        <template slot-scope="scope">
          <img :src="`${baseurl}/${scope.row.logo}`" style="width: 50px; border: 1px solid #eee; margin-right: 10px;" alt="">
        </template>
      </el-table-column>
      <el-table-column prop="telephone" label="公司电话" width="">
        <template slot-scope="scope">
          <div v-for="(item, index) in formenttelephone(scope.row.telephone)" :key="index">{{ item.number }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="address" label="公司地址" width=""></el-table-column>
      <el-table-column label="状态" width="100">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.status == '1'" type="success" size="mini">正常</el-tag>
          <el-tag v-else-if="scope.row.status == '2'" type="info" size="mini">停用</el-tag>
        </template>
      </el-table-column>
      <el-table-column v-if="userPrower == '1'" label="操作" width="">
        <template slot-scope="scope">
          <el-button type="text" size="mini" icon="el-icon-view" @click="showDetail(scope.row)">查看详情</el-button>
          <!-- <el-button type="text" size="mini" @click="onUpdateState(scope)">
            {{ scope.row.state == '1' ? '停用' : '启用' }}
          </el-button>
          <el-button type="text" size="mini" icon="el-icon-edit" @click="onUpdate(scope)">编辑</el-button>
          <el-button type="text" size="mini" icon="el-icon-delete" @click="onDelete(scope)">删除</el-button> -->
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <el-pagination
    :current-page.sync="currentPage"
    :page-size="pageSize"
    hide-on-single-page
    background
    layout="total, prev, pager, next"
    :total="total"
    @current-change="handleCurrentChange">
    </el-pagination>

    <!-- 查看详情 -->
    <el-dialog title="企业详情" :visible.sync="dialogDetailVisible" @close="imageDialogClose" :show-close="true" style="margin-top: -50px;">
      <div class="active-detail" style="text-align: center;margin-top: -20px;">
        <el-descriptions class="margin-top" :column="2" border>
          <el-descriptions-item>
            <template slot="label">
              <div style="width: 100px;">
                企业名称
              </div>
            </template>
            <div style="width: 150px">
              {{ activeObj.name }}
            </div>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <div style="width: 100px;">
                企业logo
              </div>
            </template>
            <div style="width: 150px;">
              <el-tooltip placement="top" v-if="activeObj.logo">
                <img v-if="activeObj.logo" :src="`${baseurl}/${activeObj.logo}`" style="width: 50px; height: 50px; border-radius: 50%; border: 1px solid #eee; margin-right: 10px;" alt="">
                <div slot="content">
                  <img v-if="activeObj.logo" :src="`${baseurl}/${activeObj.logo}`" style="width: 300px;" alt="">
                </div>
              </el-tooltip>
            </div>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <div style="width: 100px;">
                电话
              </div>
            </template>
            <div style="width: 150px">
              <div v-for="(item, index) in formenttelephone(activeObj.telephone)" :key="index">{{ item.number }}</div>
            </div>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <div style="width: 100px;">
                公司地址
              </div>
            </template>
            <div style="width: 150px">
              {{ activeObj.address }}
            </div>
          </el-descriptions-item>
          <el-descriptions-item v-if="activeObj.is_multiple_address == '1'">
            <template slot="label">
              <div style="width: 100px;">
                多地址
              </div>
            </template>
            <div style="width: 150px">
              <ol>
                <li v-for="(item, index) in formentAddress(activeObj.multiple_json)" :key="index">{{ item.address }}</li>
              </ol>
            </div>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <div style="width: 100px;">
                企业视频
              </div>
            </template>
            <div style="width: 150px">
              <video v-if="activeObj.video_url" :src="`${baseurl}/${activeObj.video_url}`" style="width: 100px;border: 1px solid #eee;"></video>
            </div>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <div style="width: 100px;">
                视频封面
              </div>
            </template>
            <div style="width: 150px">
              <el-tooltip placement="top" v-if="activeObj.video_image">
                <img v-if="activeObj.video_image" :src="`${baseurl}/${activeObj.video_image}`" style="width: 100px; border: 1px solid #eee;" alt="">
                <div slot="content">
                  <img v-if="activeObj.video_image" :src="`${baseurl}/${activeObj.video_image}`" style="width: 300px;" alt="">
                </div>
              </el-tooltip>
            </div>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <div style="width: 100px;">
                企业海报
              </div>
            </template>
            <div style="width: 150px">
              <el-tooltip placement="top" v-if="activeObj.poster_path">
                <img v-if="activeObj.poster_path" :src="`${baseurl}/${activeObj.poster_path}`" style="width: 100px; border: 1px solid #eee;" alt="">
                <div slot="content">
                  <img v-if="activeObj.poster_path" :src="`${baseurl}/${activeObj.poster_path}`" style="width: 300px;" alt="">
                </div>
              </el-tooltip>
            </div>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <div style="width: 100px;">
                企业简介
              </div>
            </template>
            <div style="width: 150px">
              <el-tooltip placement="top" v-if="activeObj.desc_images">
                <img v-if="activeObj.desc_images" :src="`${baseurl}/${activeObj.desc_images}`" style="width: 50px; border: 1px solid #eee;" alt="">
                <div slot="content">
                  <img v-if="activeObj.desc_images" :src="`${baseurl}/${activeObj.desc_images}`" style="height: 500px;" alt="">
                </div>
              </el-tooltip>
            </div>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <div style="width: 100px;">
                产品中心
              </div>
            </template>
            <div style="width: 150px">
              <span v-if="activeObj.show_product == '1'">展示</span>
              <span v-else-if="activeObj.show_product == '-1'">隐藏</span>
            </div>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <div style="width: 100px;">
                服务中心
              </div>
            </template>
            <div style="width: 150px">
              <span v-if="activeObj.show_services == '1'">展示</span>
              <span v-else-if="activeObj.show_services == '-1'">隐藏</span>
            </div>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <div style="width: 100px;">
                创建时间
              </div>
            </template>
            <div style="width: 150px">
              {{ activeObj.create_time }}
            </div>
          </el-descriptions-item>
        </el-descriptions>
      </div>
    </el-dialog>

  </div>
</template>

<script>
export default {
  name: 'StorePage',

  data() {
    return {
      userPrower: '', // 用户权限
      name: '', // 姓名
      company_name: '', // 公司名称
      info_no: '', // 企业编号
      tableData: [],
      loading: false,
      currentPage: 1,
      pageSize: 10,
      total: 0,
      activeObj: {},
      dialogDetailVisible: false,
      baseurl: '',
    };
  },

  mounted() {
    this.baseurl = this.$baseUrl
    let userInfo = localStorage.getItem('userInfo')
    if (userInfo) {
      userInfo = JSON.parse(userInfo)
      this.userPrower = userInfo.prower
    } else {
      this.$http({
        method: 'post',
        url: 'user_exit'
      })
      this.$router.push({
        path: '/login'
      })
    }
    this.getData()
  },
  
  methods: {
    getData() {
      this.loading = true
      this.$http({
        method: 'post',
        url: `/information/find?page=${this.currentPage}&pageSize=${this.pageSize}`,
        params: {
          info_no: this.info_no
        }
      })
      .then(res => {
        this.loading = false
        if (res.errno == 0) {
          const { data, page, pageSize, count } = res.data
          this.tableData = data
          this.currentPage = page
          this.pageSize = pageSize
          this.total = count
        } else {
          this.$message.error('查询失败')
        }
      })
      .catch(err => {
        this.loading = false
        this.$message.error('服务端异常，查询失败')
        console.error('查询异常：', err.message);
      })
    },
    tableHeaderColor({row, column, rowIndex, columnIndex}) {
      return 'background-color: #F2F2F2;color:#101010;'
    },
    onSearch() {
      this.currentPage = 1
      this.getData()
    },
    toAddStorePage() {
      this.$router.push({
        path: '/addInformation'
      })
    },
    // 页码改变
    handleCurrentChange(page) {
      this.currentPage = page
      this.getData()
    },
    // 多电话解析
    formenttelephone(telephone) {
      if (telephone) {
        try {
          let list = JSON.parse(telephone)
          return list
        } catch(e) {
          return []
        }
      }
      return []
    },
    // 解析多地址
    formentAddress(address) {
      if (address) {
        try {
          let list = JSON.parse(address)          
          return list
        } catch(e) {
          return []
        }
      }
      return []
    },
    // 查看名片详情
    showDetail(row) {
      this.activeObj = row
      this.dialogDetailVisible = true
    },
    onUpdateState({ row, $index }) {
      const status = row.status == '1' ? '2' : '1'
      this.$confirm(`确定要${row.status == '1' ? '停用' : '启用'} ${row.name} 的账号吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true
        this.$http({
          method: 'post',
          url: '/information/update',
          params: {
            id: row.id,
            status
          }
        })
        .then(res => {
          this.loading = false
          if (res.errno == 0) {
            this.$message.success('操作成功')
            this.getData()
          } else {
            this.$message.error('操作失败')
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('操作异常')
        })
      }).catch(() => {});
    },
    onUpdate(scope) {
      sessionStorage.setItem('updateInformation', JSON.stringify(scope.row))
      this.$router.push({
        path: '/updateInformation',
        query: {
          id: scope.row.id
        }
      })
    },
    onDelete(scope) {
      this.$confirm(`确定要删除 ${scope.row.name} 吗？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$http({
            method: 'post',
            url: '/information/delete',
            params: {
              id: scope.row.id
            }
          })
          .then(res => {
            if (res.errno == 0) {
              this.$message.success('删除成功')
              this.getData()
            } else {
              this.$message.error('服务端异常，网点删除失败')
            }
          })
          .catch(err => {
            this.$message.error('服务端异常，网点删除失败')
          })
        }).catch(() => {});
    },
    // 查看图片弹框关闭
    imageDialogClose() {
      this.activeObj = {}
      this.dialogDetailVisible = false
    },
  },
};
</script>

<style lang="scss" scoped>
.page-container {
  background: #fff;
  height: 100%;
  width: 100%;
  border-radius: 3px;
  box-sizing: border-box;
  padding: 20px 25px;
  overflow-y: scroll;

  .page-top-tool {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 12px;
  }
}

/* 修改滚动条样式 */
.page-container::-webkit-scrollbar {
	width: 4px;
}
.page-container::-webkit-scrollbar-thumb {
	border-radius: 10px;
	-webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
	background: rgba(0, 0, 0, 0.2);
}

.active-detail {
  position: relative;
  .shenpi-resuilt-img {
    position: absolute;
    width: 120px;
    top: -70px;
    right: 0px;
    opacity: 0.6;
  }

  .active-images-layout {
    display: flex;
    flex-wrap: wrap;
    .active-images-item {
      margin: 20px;
      cursor: pointer;
    }
  }
}

.active-detail-dialog {
  height: 480px;
  overflow-y: scroll;
}
.active-detail-dialog-bottom {
  margin-top: 20px;
  text-align: right;
}

/* 修改滚动条样式 */
.active-detail-dialog::-webkit-scrollbar {
	width: 4px;
}
.active-detail-dialog::-webkit-scrollbar-thumb {
	border-radius: 10px;
	-webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
	background: rgba(0, 0, 0, 0.2);
}

.copy-link {
  margin-left: 10px;
  color: #409EFF;
}
.copy-link:hover {
  cursor: pointer;
}
.url-style {
  text-decoration: none;
  color: #409EFF;
}
</style>